/// <reference path="../../../app.definition.ts" />

import * as angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PopUpService } from "@common/popup/popup.service";
import { Util } from "@common/util";
import { PermissionsEnum, TargetEnum } from "@common/model/subject";
import { ITeamRoleService } from "@common/service/teamRole.service";
import { CacheService } from "@common/service/cache.service";
import { IProjectTypeService } from "@common/service/projectTypes.service";
import { IUserService } from "@common/service/user.service";
import { IEventLocationService } from "@common/service/eventLocation.service";
import { PermissionService } from "ecv/common/permissions";
import { IAppRootScopeService } from "@/app/app.definition";

export class EcvChoicesListType {
    customChoices: IEcvCustomChoices;
    constructor(customChoices: IEcvCustomChoices) {
        if (!customChoices) {
            console.log("EcvChooseMeChoiceList: missing chooseMe");
        }
        !!customChoices && (this.customChoices = customChoices);
    }


}

class TeamRolesList extends EcvChoicesListType {
    selectedSubject: any;
    constructor(customChoices: IEcvCustomChoices) {
        super(customChoices);
    }
    addMe: (role: string) => void = (role: string) => {
        let subjectTypeId = this.customChoices.subjectTypeId;
        let subjectOrgId = this.customChoices.subjectOrgId || this.customChoices.$_cache.getUser().organizationId;
        this.customChoices.api.addTeamRole(role, subjectTypeId).then((s) => {
            this.customChoices.$_teamRoleService.orgTeamRoles[subjectOrgId] = s;
            this.customChoices.choiceList = s.filter(function (role) {
                return !subjectTypeId || !role.subjectTypeId || (role.subjectTypeId == subjectTypeId || role.subjectTypeId == "BOTH");
            });
            const newRole = this.customChoices.choiceList.find(function (element) {
                return element.roleName == role && (element.subjectTypeId == subjectTypeId || element.subjectTypeId == "BOTH");
            });
            this.customChoices.item.teamRoleId = newRole.id;
            this.customChoices.item.teamRole = newRole.roleName;
            this.customChoices.item.name = newRole.roleName;
            this.customChoices.selectedId = newRole.id;
            this.customChoices.selectedName = newRole.roleName;


            this.customChoices.timeout(function () {
                angular.element('#ddlTeamRole').click();
            }, 100);
        }, (e) => {
            this.customChoices.pop.openInformationModal(e);
        });
    }
}

class ProjectTypesList extends EcvChoicesListType {
    constructor(customChoices: IEcvCustomChoices) {
        super(customChoices);
    } addMe: (role: string) => void = (role: string) => {
        this.customChoices.api.addProjectType(role).then((s) => {
            this.customChoices.choiceList = s;
            const newRole = s.find(function (element) {
                return element.roleName == role;
            });
            this.customChoices.item.teamRoleId = newRole.id;
            this.customChoices.item.teamRole = newRole.roleName;
            this.customChoices.timeout(function () {
                angular.element('#ddlTeamRole').click();
            }, 100);
            Util.setProjectTypes(s);
        }, (e) => {

        });
    }
}
class ServiceLocationList extends EcvChoicesListType {
    constructor(customChoices: IEcvCustomChoices) {
        super(customChoices);
    }
}

class EventLocationList extends EcvChoicesListType {
    constructor(customChoices: IEcvCustomChoices) {
        super(customChoices);
    }
}

class FieldCategoriesList extends EcvChoicesListType {
    constructor(customChoices: IEcvCustomChoices) {
        super(customChoices);
    }
    addMe: (category: string) => void = (category: string) => {
        const context = this;
        if (!context.customChoices.errorMsg) {
            context.customChoices.newInfoCount = context.customChoices.newInfoCount - 1;
            context.customChoices.choiceList.push({
                id: context.customChoices.newInfoCount,
                name: category,
            });
            context.customChoices.selectedId = context.customChoices.newInfoCount;
            context.customChoices.item.id = context.customChoices.newInfoCount;
            context.customChoices.item.name = category;
            context.customChoices.item.searchData = category;
            context.customChoices.timeout(function () {
                angular.element('#ddlTeamRole').click();
            }, 100);
        }
    }
    validateNewMetadata: (newItem: string) => void = (newItem: string) => {
        const context = this;
        let regex = /^[a-zA-Z0-9- _.,()//]*$/;
        if (newItem.length > 50) {
            context.customChoices.errorMsg = "Category cannot exceed above 50 characters";
        } else if (!regex.test(newItem)) {
            context.customChoices.errorMsg = "Invalid characters.";
        } else {
            context.customChoices.errorMsg = null;
        }
    }
}

export interface IEcvCustomChoices {
    $_teamRoleService: ITeamRoleService;
    $_cache: CacheService;
    subjectTypeId: any;
    item: any;
    listType: string;
    selectedId: number;
    selectedName: string;
    selectedOrder: string;
    choiceList;
    choiceListType;
    addNewItemInList;
    api: JavaApiAdapterService;
    timeout: ng.ITimeoutService;
    fieldLabel: string;
    noChoiceText: string;
    disable: boolean;
    placeholderText: string;
    hideAddOption: boolean;
    pop;
    formField: any;
    exactSearchParam: string;
    metaDetail: any;
    entityName: any;
    newInfoCount: number;
    errorMsg: string;
    subjectOrgId;
    rootScope: ng.IScope;
    init(): void;
}

class EcvCustomChoices implements IEcvCustomChoices {
    item: any;
    listType: string;
    selectedId: number;
    selectedName: string;
    selectedOrder: string;
    choiceList;
    choiceListType;
    api: JavaApiAdapterService;
    timeout: ng.ITimeoutService;
    fieldLabel: string;
    noChoiceText: string;
    disable: boolean;
    placeholderText: string;
    hideAddOption: boolean;
    selectedSubject: any;
    pop;
    formField: any;
    exactSearchParam: string;
    metaDetail: any;
    entityName: any;
    newInfoCount: number;
    errorMsg: string;
    isRequired: boolean = true;
    subjectOrgId;
    subjectTypeId: any;
    $_teamRoleService: ITeamRoleService;
    $_cache: CacheService;
    rootScope: ng.IScope;
    static $inject = ['CacheService', '$rootScope', 'TeamRoleService', 'ProjectTypeService', 'UserService', 'ApiAdapterService', '$timeout',
        "EventLocationService", "PopUpService", "PermissionService"];
    constructor(
        $_cache: CacheService,
        $rootScope: IAppRootScopeService,
        teamRoleService: ITeamRoleService,
        private $_projectTypeService: IProjectTypeService,
        private $_user: IUserService,
        private $_api: JavaApiAdapterService,
        private $_timeout: ng.ITimeoutService,
        private $_eventLocationService: IEventLocationService,
        private $_pop: PopUpService,
        private PermissionService
    ) {
        this.api = $_api;
        this.timeout = $_timeout;
        this.pop = $_pop;
        this.rootScope = $rootScope;
        this.$_teamRoleService = teamRoleService;
        this.$_cache = $_cache;
    }


    getTeamRoles = () => {
        const context = this;
        if (!context.subjectTypeId && (!context.selectedSubject || !context.selectedSubject.subjectTypeId)) {
            this.$_teamRoleService.getTeamRoles(context.subjectOrgId).then((s) => {
                context.choiceList = s;
            });
        } else {
            const subjectTypeId = context.subjectTypeId || context.selectedSubject.subjectTypeId;
            this.$_teamRoleService.getTeamRoles(context.subjectOrgId, subjectTypeId).then((s) => {
                context.choiceList = s;
            });
        }
    }


    // change for get project types
    getProjectTypes = () => {
        const context = this;
        this.$_projectTypeService.getProjectTypes().then((s) => {
            context.choiceList = s;
        });
    }
    getServiceLocations = () => {
        const context = this;
        let locations = Util.getServiceLocations();
        if (!!locations && locations.length > 0) {
            context.choiceList = locations;
        } else {
            this.$_teamRoleService.getTeamRoles(this.selectedSubject.subjectTypeId).then((s) => {
                context.choiceList = s;
            });
        }

    }

    getEventLocations = () => {
        const context = this;
        // let locations = ;
        // if (!!locationsUtil.getServiceLocations() && locations.length > 0) {
        //     context.choiceList = locations;
        // } else {
        this.$_eventLocationService.getEventLocations().then((s) => {
            context.choiceList = s;
        });
        // }

    }
    getMetadataInfoList = () => {
        const context = this;
        const metaObj = {
            entityName: this.choiceListType.customChoices.entityName,
            entityType: "FORMDYNAMICATTRIBUTE",
            metadata: this.choiceListType.customChoices.fieldLabel
        };

        this.$_api.getFormFieldMetadataInfo(metaObj).then((s) => {
            if (s.length > 0) {
                context.choiceListType.customChoices.item.metaDetail = s[0];
                context.choiceList = JSON.parse(s[0].listOptions);
            } else {
                context.choiceList = [];
            }
        });
    }

    init(): void {
        if (!!this.hideAddOption) {
            //do nothing
        } else {
            this.hideAddOption = false;
        }
        this.selectedSubject = this.$_cache.getCurrentSubject();
        switch (this.listType) {
            case "TeamRole":
            case "TeamCaptainRole":
            case "TeamCaptain":
            case "ProjectRole":
            case "TeamProjectRole":
                this.choiceListType = new TeamRolesList(this);
                this.exactSearchParam = "roleName";
                //If subjectOrgId is not available then fetch teamOrgId from selected CR
                if (!this.subjectOrgId && this.selectedSubject) {
                    this.subjectOrgId = this.selectedSubject.teamOrgId;
                }
                this.getTeamRoles();
                let currentUser = this.$_cache.getUser();
                this.PermissionService.isActionAllowed(currentUser.partyId, TargetEnum.TEAM_ROLE, PermissionsEnum.CREATE)
                    .then((isPermitted) => {
                        // Hide the "Add New" option if the user doesn't have permission or isn't part of the same organization.
                        this.hideAddOption = !isPermitted || (!!this.subjectOrgId && currentUser.organizationId !== this.subjectOrgId);
                        // Set the noChoiceText if the Add Option is hidden and noChoiceText is not set.
                        if (this.hideAddOption && !this.noChoiceText) {
                            this.noChoiceText = "No match found.";
                        }
                    });
                break;
            case "ProjectType":
                this.choiceListType = new ProjectTypesList(this);
                this.getProjectTypes();
                break;
            case "ServiceLocation":
                this.choiceListType = new ServiceLocationList(this);
                this.getServiceLocations();
                break;
            case "EventLocation":
                this.choiceListType = new EventLocationList(this);
                this.getEventLocations();
                break;
            case "FieldCategories":
                this.choiceListType = new FieldCategoriesList(this);
                this.exactSearchParam = "name";
                this.newInfoCount = 0;
                this.getMetadataInfoList();
                break;
            default:
                console.error("EcvChooseMe: Item type of '", this.listType, "not currently supported");
                break;
        }


    }

    exactSearchInList = (list, search, attr?) => {
        return !!(list || []).find(itm => attr ? itm[attr].toLowerCase() == search.toLowerCase() : itm.toLowerCase() == search.toLowerCase());
    }

    addCustomItem = (str, customItem, select) => {
        if (str.keyCode == 13 && !!customItem) {
            const roleExist = this.choiceList.find(function (item) {
                return item.name.toLowerCase() == customItem.toLowerCase();
            });

            if (!roleExist) {
                this.addNewItemInList(customItem);
            }
        }
        if (this.listType == "FieldCategories") {
            this.choiceListType.validateNewMetadata(customItem);
        }
    }

    addNewItemInList = (item: string) => {
        this.choiceListType.addMe(item);
    }





}

function customChoices(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        template: `
                <span>
                    <div class="ecv-static-choice cr-selector-static">
                         <span class="new-choice-padding" ng-click="customChoicesVm.addNewItemInList($select.search)" ng-hide="customChoicesVm.hideAddOption || !$select.search || customChoicesVm.exactSearchInList($select.items, $select.search, customChoicesVm.exactSearchParam)">
                             <div class="stop-click add-role white-space">Click to add new {{customChoicesVm.fieldLabel}} - '<span ng-bind="$select.search"></span>'</div>
                         </span>
                    </div>
                    <ui-select id="ddlTeamRole" ecv-static-choices
                        ng-keyup="customChoicesVm.addCustomItem($event,$select.search, $select.selected)"
                        ng-model="customChoicesVm.selectedId"
                        ng-disabled="customChoicesVm.disable"
                        tooltip-class="meta-cancel-tooltip"
                        uib-tooltip="{{customChoicesVm.errorMsg}}" tooltip-trigger="'none'" tooltip-append-to-body="true" tooltip-placement="top auto" tooltip-is-open='!!customChoicesVm.errorMsg'
                        class="stop-click selectInput" ng-class="{'select-focus':$select.focus}"
                        theme="bootstrap" search-enabled="searchEnabled" validator="required={{customChoicesVm.disable? false : customChoicesVm.isRequired}}"
                        name="{{customChoicesVm.listType}}" valid-method="submit" message-id="require{{customChoicesVm.listType}}">
                        <ui-select-match class="stop-click" placeholder="{{customChoicesVm.placeholderText}}">
                            {{$select.selected.name || customChoicesVm.selectedName}}
                        </ui-select-match>
                        <ui-select-choices class="stop-click"
                            repeat="item.id as item in (customChoicesVm.choiceList | filter: $select.search | orderBy:customChoicesVm.selectedOrder)">
                            <span class="stop-click" ng-bind="item.name"></span>
                        </ui-select-choices>
                        <ui-select-no-choice class="new-choice-padding">
                              <span ng-if="!customChoicesVm.hideAddOption" class="stop-click add-role white-space" ng-click="customChoicesVm.addNewItemInList($select.search)">
                                Press Enter to add new {{customChoicesVm.fieldLabel}} - '{{ $select.search }}'
                              </span>
                              <span ng-if="!!customChoicesVm.noChoiceText" class="hidden-xs no-matching-records">
                                {{customChoicesVm.noChoiceText}}
                              </span>
                              <span ng-if="!!customChoicesVm.noChoiceText" class="visible-xs no-matching-records">
                                No match
                              </span>
                        </ui-select-no-choice>
                    </ui-select>
                    <label ng-if="customChoicesVm.fieldLabel" class="lblTeamRole">{{customChoicesVm.fieldLabel}}
                    </label>
                    <span id="require{{customChoicesVm.listType}}" class="stop-click error-msg error-msg-0padding"></span>
                </span>
            `,
        controller: EcvCustomChoices,
        controllerAs: 'customChoicesVm',
        bindToController: {
            'item': '=item',
            'listType': '@listType',
            'selectedId': '=selectedId',
            'selectedName': '=selectedName',
            'fieldLabel': '@?fieldLabel',
            'noChoiceText': '@?noChoiceText',
            'disable': '=?disableField',
            'placeholderText': '@placeholderText',
            'hideAddOption': '=?hideAddOption',
            'selectedOrder': '=selectedOrder',
            'subjectTypeId': '=subjectTypeId',
            'isRequired': '@?',
            'formField': '=formField',
            'entityName': '=entityName',
            'subjectOrgId': '=?subjectOrgId'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvCustomChoices): void => {
            controller.init();
            // scope.$watch(() => {
            //     return !!controller.attachment ? controller.attachment.extension : null;
            // }, (newVal, oldVal) => {
            //     if (!!newVal && newVal != oldVal) {
            //         controller.init();
            //     }
            // });
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvCustomChoices', customChoices);

